import { Fab, styled } from '@mui/material'

export const ChatListFab = styled(Fab)`
  position: absolute;
  transition:
    opacity 0.3s ease,
    transform 0.4s ease;
  &.hide {
    transform: translateY(15px);
    opacity: 0;
    pointer-events: none;
  }
`
